import { Route, Switch } from "react-router-dom";

import CanadaClawbackInstrumentLinkPage from "@faire/prototype-playground/workspace/sw/canada-clawback-instrument-link";

export function ShengchaoWangRoutes() {
  return (
    <Switch>
      <Route path="/sw/canada-clawback-instrument-link" component={CanadaClawbackInstrumentLinkPage} />
    </Switch>
  );
}

export const slug = "sw";
